import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, FormGroup, Form, Input, Button, Spinner } from "reactstrap";

// helpers
import { showMessage } from "helpers/message.js";
import { removeAllCookies } from "helpers/cookies.js";

// api
import usuario_api from "api/usuario_api.js";

export default function EsqueciSenha({ history }) {

    const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    useEffect(() => {
        removeAllCookies();
    }, []);

    const onSubmit = (data) => {
        let json_submit = data.email
        
        setshowLoading(true);
        usuario_api.esqueceu_senha(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else if (result.data == null) {
                showMessage("Aviso", "Usuário não encontrado", 'warning', null);
            }
            else {
                showMessage("Aviso", "Uma senha temporária foi enviada para seu email!", 'success', function(){
                    history.push("/auth/login");
                });
            }
        });  
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Row style={{ marginTop: "15vh" }}>
                <Col lg="3" md="12" className="text-center">
                </Col>
                <Col lg="6" md="12" className="text-center">
                    <Card>
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="12" lg="12">
                                        <h5 className="text-center">Preencha para recuperar sua senha</h5>
                                        <FormGroup>
                                            <label>Email</label>
                                            <Input type="email" name="email" maxLength="200" innerRef={register({ required: true })} />
                                            {errors.email && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                        <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/login"); }}>Voltar</a>
                                    </Col>
                                </Row>
                                <div className="text-right">
                                    <Button color="info" className="btn-mobile" type="submit">ENVIAR EMAIL </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
                <Col lg="3" md="12" className="text-center">
                </Col>
            </Row>
        </>
    );
}